export default __webpack_public_path__ + "static/media/sm.90b0d521.svg";